import "react-day-picker/lib/style.css"
import "./DayPicker.css"

import { useState } from "react"
import DayPickerBase from "react-day-picker"

import { formatToLocalDateTime } from "web/services/helpers"
import { formatAsDate } from "web/services/format"
import { fromMonth, toMonth, YearMonthForm } from "."

export default function DayPicker({ onChange, value }) {
  const valueInDateTime = formatToLocalDateTime(value)
  const valueInJSDate = valueInDateTime
    ? valueInDateTime.toJSDate()
    : valueInDateTime

  const [date, setDate] = useState(valueInJSDate)

  return (
    <DayPickerBase
      month={date}
      fromMonth={fromMonth}
      toMonth={toMonth}
      selectedDays={valueInJSDate}
      onDayClick={(date) => onChange(formatAsDate({ value: date }))}
      captionElement={({ date, localeUtils }) => (
        <YearMonthForm
          date={date}
          localeUtils={localeUtils}
          onChange={setDate}
        />
      )}
    />
  )
}
